import endpointConfig from "../configs/endpoint.config";
import httpConfig from "../configs/http.config";
import { TeamPayloadProps, TeamResponseProps } from "../types/team.type";

const teamService = {
  get: async function(body: TeamPayloadProps) {
    const response = await httpConfig().post<TeamResponseProps>(endpointConfig.team.get, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  }
}

export default teamService